import styled from 'styled-components';
import breakpoint from 'styled-components-breakpoint';
import {
  p, py, mt, m
} from 'styled-components-spacing';

import Grid from 'styled-components-grid';
import theme from '@theme';

export const StyledCover = styled.div`
  height: fit-content;
`;

export const StyledTimelineWapper = styled(Grid)`
  color: ${theme.colors.white};
  text-align: center;
  ${m(3)};
  ${breakpoint('tablet', 'desktop')`
     width: 100%;
     flex-direction: column;
     height: 450px;
     max-width: 780px;
     margin: auto;
  `}
`;

export const StyledTimelineTitle = styled.div`
  ${p(3)};
  font-size: 24px;
  ${breakpoint('desktop')`
    place-items: center;
    flex-direction: column;
    display:${props => (props.laptop ? 'none' : 'justify')}
  `}
  ${breakpoint('mobile', 'tablet')`
    font-size: 20px;
    display:${props => (props.mobile ? 'none' : 'block')}
    text-align: start;
  `}
  ${breakpoint('tablet', 'desktop')`
    font-size: 17px;
    display:${props => (props.laptop ? 'none' : 'block')}
  `}
  @media (min-width: 1024px) and (max-width: 1460px){
    font-size: 19px;
  }
`;

export const StyledTimeline = styled(Grid.Unit)`
  display: flex;
  padding: 1px;
  ${breakpoint('desktop')`
  place-items: center;
  flex-direction: column;
`}
  ${breakpoint('mobile', 'tablet')`
    float:left;
    flex-direction: row;
    flex-wrap:nowrap;
    width:100%;
    justify-content: center;
  `}
  ${breakpoint('tablet', 'desktop')`
   flex-direction: column;
    align-items: center;
    justify-content: flex-start;
    height: auto;
  `}
`;

export const StyledTimelinePoint = styled.div`
  position: relative;
  top: 4px;
  background-color: ${theme.colors.white};
  ${p(2)}
  width: 5px;
  height: 5px;
  border-radius: 100%;
  ${breakpoint('mobile', 'tablet')`
  float:left;
  height: 5px;
  top: 17px;
  left: 4px;
  position: relative;
`}
 ${breakpoint('tablet', 'desktop')`
   top: -11px;
 `}
`;

export const StyledTimelineDesciption = styled.div`
  color: ${theme.colors.mediumGray};
  font-size: 17px;
  line-height: 1.2em;
  text-align: start;
  padding: 10px;
  @media (min-width: 300px) and (max-width: 500px){
    height: 210px;
  }
  @media (min-width: 500px) and (max-width: 736px){
    height: 170px;
  }
  ${breakpoint('tablet', 'desktop')`
    ${m(0)}
  `}
`;

export const StyledTimelineDesciptionCard = styled.div`
  width: 215px;
  background-color: ${theme.colors.white};
  height: 300px;
  border-radius: 24px;
  ${m(3)}
  ${breakpoint('tablet', 'desktop')`
    height: 310px;
    max-width:100%;
    width: 150px;
    border-radius: 15px;
  `}
  @media (min-width: 1024px) and (max-width: 1460px){
    width: 180px;
    border-radius: 15px;
  }
`;

export const StyledLogoWrapper = styled.div`
  margin: 0 auto;

  img {
    border-radius: 15px 15px 0px 0px;
    width: 100%;
    height: 100%;
  }
`;

export const StyledTimelineBorder = styled.div`
  ${breakpoint('desktop')`
  border-top: 2px solid white;
  color: white;
  width: 101%;
  padding: 0;
  margin: 0;
  top: 15px;
  position: relative;`}
  ${breakpoint('mobile', 'tablet')`
    height: 101%;
    left: 16px;
    position: relative;
    border-left: 2px solid white;
  `}

  ${breakpoint('tablet', 'desktop')`
    width: 101%;
     position: relative;
    border-top: 2px solid white;
  `}
`;

export const StyledTImelineResponsiveWrapper = styled.div`
  height: 100%;
  width: 100%;
  ${breakpoint('desktop')`
    display:flex;
    flex-direction:column;
    padding: 1rem 0rem;
  `}

  ${breakpoint('mobile', 'tablet')`
    width: auto;
    display:flex;
    flex-direction:column;
    padding:2px;
    padding-left:1rem;
    float:right;
  `}
${breakpoint('tablet', 'desktop')`
  padding-left: 0rem;
  height: auto;
`}
  @media (min-width: 1024px) and (max-width: 1460px){
     ${mt(2)}
  }
`;

export const StyledAimSection = styled.div`
  text-align: start;
`;

export const StyledAboutHeading = styled.h1`
  font-size: 30px;
  font-weight: bold;
  color:#136C9D;
  padding-top:1rem;
  padding-bottom: 1rem;
  text-align: center;
  ${breakpoint('mobile', 'tablet')`
    line-height:1.2;
    font-size: 22px;
    padding-bottom:1rem;
  `}
`;

export const StyledWidthWrapper = styled.div`
background: #2F8DE3;
`;

export const StyledAimMainWrapper = styled.div`
max-width: 1500px;
margin: auto;
margin-top: 2rem;
padding:3rem 6rem;
display:flex;
justify-content: center;
${breakpoint('mobile', 'tablet')`
  ${p(0)};
  ${mt(2)};
  ${py(2)};
  flex-direction: column;
  align-items: flex-start;
`}
${breakpoint('tablet', 'desktop')`

  padding: 0;
`}
  margin: auto;
 @media (min-width: 350px) and (max-width: 500px){
  max-width:330px;
  margin: auto;
 }

 @media (min-width: 500px) and (max-width: 736px){
  max-width: 440px;
  margin: auto;
 }
`;
